import { Chakra } from "@airhelp/react-ui-components";
import type { FlexProps } from "@chakra-ui/react";

const { Flex } = Chakra;

const ListWrapper = ({ children, ...props }: FlexProps) => (
  <Flex
    flexDir="column"
    p={{ base: 0, md: 6, lg: 8 }}
    borderRadius={{ base: "none", md: "md" }}
    w={{ base: "100%", md: "45vw", lg: "45vw", xl: "30vw" }}
    textAlign="left"
    {...props}
  >
    {children}
  </Flex>
);

export default ListWrapper;
